<template>
    <div class="font-black text-center text-[40px] mb-[15px] sm:mb-[30px]">FORECAST</div>
    <div class="grid mb-5">
        <label class="mb-[5px]">Username</label>
        <input type="text" placeholder="Username" v-model="user" />
    </div>
    <div class="grid mb-5">
        <label class="mb-[5px]">Password</label>
        <input type="password" placeholder="Password" v-model="pw" />
    </div>

    <div class="flex justify-between items-center">
        <div class="flex items-center" @click="rememberMe = !rememberMe">
            <input class="w-[18px] h-[18px]" type="checkbox" v-model="rememberMe" />
            <label class="ml-[5px]">Ricordami</label>
        </div>
        <span></span>
        <!--<span>Password dimenticata</span>-->
    </div>

    <div class="flex justify-end">
        <button class="button mt-[20px] py-[10px] px-[15px]" @click="handleLogin">ACCEDI</button>
    </div>
</template>

<script>
import { mainStore } from '../../../store/main';

export default {
    name: 'LoginView',

    data() {
        return {
            mainStore,
            user: null,
            pw: null,
            rememberMe: false,
        }
    },

    created() {
        const loader = this.$loading.show();

        if (localStorage.getItem("user") && localStorage.getItem("pw")) {
            this.rememberMe = true;
        }
        this.user = localStorage.getItem("user");
        this.pw = localStorage.getItem("pw");
        if (this.$cookies.get("token_forecast")) {
            this.mainStore.access_token_forecast = this.$cookies.get("token_forecast");
        }
        if (this.$cookies.get("refreshToken_forecast")) {
            this.mainStore.refresh_token_forecast = this.$cookies.get("refreshToken_forecast");
        }

        loader.hide();
    },

    methods: {
        async handleLogin() {
            if (!this.user) {
                this.$notify({
                    title: "Attenzione",
                    text: "Username mancante",
                    type: "warn",
                });
                return false;
            }
            if (!this.pw) {
                this.$notify({
                    title: "Attenzione",
                    text: "Password mancante",
                    type: "warn",
                });
                return false;
            }

            await this.login();
        },
        async login() {
            const loader = this.$loading.show();

            try {
                const response = await this.$axios.post(`${process.env.VUE_APP_HOST}/auth/realms/${process.env.VUE_APP_REALM_FORECAST}/protocol/openid-connect/token`, {
                    username: this.user,
                    password: this.pw,
                    grant_type: "password",
                    client_id: process.env.VUE_APP_CLIENT_ID_FORECAST,
                }, { headers: { "content-type": "application/x-www-form-urlencoded" } })

                this.$cookies.set("token_forecast", response.data?.access_token);
                this.$cookies.set("refreshToken_forecast", response.data?.refresh_token);
                this.mainStore.access_token_forecast = response.data?.access_token;
                this.mainStore.refresh_token_forecast = response.data?.refresh_token;

                this.mainStore.user = this.user;
                this.mainStore.pw = this.pw;

                if (this.rememberMe) {
                    localStorage.setItem("user", this.user);
                    localStorage.setItem("pw", this.pw);
                } else {
                    localStorage.removeItem("user");
                    localStorage.removeItem("pw");
                }
            } catch (error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella login",
                    text: error?.response?.data?.error_description ? error.response.data.error_description : error?.response?.data?.error,
                    type: "error",
                });
            }

            loader.hide();
        },

    }
}
</script>